// extracted by mini-css-extract-plugin
export default {"inputField":"InputField_inputField__sYi-Q","label":"InputField_label__rzIXk","input":"InputField_input__7-tPh"};